// ABOUTME: Live boolean from prefers-reduced-motion, subscribed to change. SSR/test-safe (Issue #1940).
// ABOUTME: The runner frame exposes this via context so screens drive JS motion (breath cue, dial rotate) off one source.

import { createContext, useContext, useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY).matches : false
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(QUERY);
    const handler = () => setReduced(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return reduced;
}

// Exported (not just the hook) so tests can wrap a screen in ReducedMotionContext.Provider directly,
// without a file-wide vi.mock of this module (Issue #1943).
export const ReducedMotionContext = createContext(false);
export const useCrossingReducedMotion = () => useContext(ReducedMotionContext);
